<template>
  <v-dialog v-model="showDialog" max-width="800" scrollable persistent>
    <v-card>
      <v-card-title
        class="pr-2"
        :style="{ backgroundColor: companyPrimaryColor }"
      >
        <h2 style="color:white">Nieuw gesprek toevoegen</h2>
        <span
          class="pl-4 pt-1 white--text"
          style="font-sze: 12px"
          v-if="autosaveBusy"
          ><i>Opslaan</i></span
        >
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closeNewDossierDialog()">
          <v-icon dark color="white">close</v-icon>
        </v-btn>
      </v-card-title>

      <v-alert class="ma-0 pa-2" v-if="feedback" :value="true" type="warning">
        {{ feedback }}
      </v-alert>

      <v-divider></v-divider>

      <v-card-text>
        <v-form ref="addDossierForm" lazy-validation>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12>
                <v-alert
                  class="ma-0 pa-2"
                  v-if="
                    !newDossier.title ||
                      !newDossier.attendees ||
                      !newDossier.employee
                  "
                  :value="true"
                  dark
                  type="info"
                >
                  <span class="white--text"
                    >Vul <strong>titel</strong>, <strong>medewerker</strong> en
                    <strong>aanwezigen</strong> in om automatisch op te
                    slaan.</span
                  >
                </v-alert>

                <v-text-field
                  class="mt-4"
                  outlined
                  :color="companyPrimaryColor"
                  background-color="background"
                  hide-details
                  label="Titel"
                  v-model="newDossier.title"
                  required
                ></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-combobox
                  multiple
                  small-chips
                  class="mt-4"
                  outlined
                  :color="companyPrimaryColor"
                  background-color="background"
                  hide-details
                  label="Aanwezigen"
                  v-model="newDossier.attendees"
                  required
                ></v-combobox>
              </v-flex>

              <v-flex xs6>
                <v-select
                  class="mt-4"
                  outlined
                  :color="companyPrimaryColor"
                  background-color="background"
                  hide-details
                  :items="dossierTypes"
                  item-text="name"
                  item-value="id"
                  v-model="newDossier.type"
                  label="Type gesprek"
                >
                </v-select>
              </v-flex>

              <v-flex xs6>
                <v-select
                  class="mt-4"
                  outlined
                  :color="companyPrimaryColor"
                  background-color="background"
                  hide-details
                  :items="employees"
                  :item-text="(item) => item.firstName + ' ' + item.lastName"
                  return-object
                  v-model="newDossier.employee"
                  label="Medewerker"
                  v-on:change="employeeSelected()"
                >
                </v-select>
              </v-flex>

              <v-flex
                xs12
                v-if="
                  newDossier.type == 'performanceReview' ||
                    newDossier.type == 'midtermReview'
                "
              >
                <div v-if="!resultActivitiesLoading">
                  <h3 class="pt-3 pb-2"><strong>Beoordeling</strong></h3>
                  <!-- <h3 class="pt-3 pb-2"><strong>Beoordeling {{ newDossier.employee.firstName }} ({{ getEmployeePosition(newDossier.employee.position) }} )</strong></h3> -->

                  <v-card
                    outlined
                    v-if="
                      newDossier.employee && resultActivitiesFiltered.length > 0
                    "
                  >
                    <v-expansion-panels flat accordion>
                      <v-expansion-panel
                        v-for="(activity, i) in resultActivitiesFiltered"
                        :key="i"
                      >
                        <v-expansion-panel-header
                          class="dossier-expansion-header"
                        >
                          <template v-slot:default>
                            <v-icon
                              style="display: block; flex: none;"
                              class="ma-0 pa-0 pr-2"
                              color="error"
                              v-if="
                                latestClientDossierHistory &&
                                  calculateAverageScore(activity.id).rating !=
                                    0 &&
                                  calculateAverageScoreHistory(activity.id)
                                    .rating &&
                                  calculateAverageScoreHistory(activity.id)
                                    .rating >
                                    calculateAverageScore(activity.id).rating
                              "
                              >mdi-chevron-down-box</v-icon
                            >
                            <v-icon
                              style="display: block; flex: none;"
                              class="ma-0 pa-0 pr-2"
                              color="warning"
                              v-if="
                                latestClientDossierHistory &&
                                  calculateAverageScore(activity.id).rating !=
                                    0 &&
                                  calculateAverageScoreHistory(activity.id)
                                    .rating &&
                                  calculateAverageScoreHistory(activity.id)
                                    .rating ==
                                    calculateAverageScore(activity.id).rating
                              "
                              >mdi-minus-box</v-icon
                            >
                            <v-icon
                              style="display: block; flex: none;"
                              class="ma-0 pa-0 pr-2"
                              color="success"
                              v-if="
                                latestClientDossierHistory &&
                                  calculateAverageScore(activity.id).rating !=
                                    0 &&
                                  calculateAverageScoreHistory(activity.id)
                                    .rating &&
                                  calculateAverageScoreHistory(activity.id)
                                    .rating <
                                    calculateAverageScore(activity.id).rating
                              "
                              >mdi-chevron-up-box</v-icon
                            >
                            {{ activity.name }} ({{
                              calculateAverageScore(activity.id).ratings
                            }}/{{ activity.criteria.length }})
                            <v-rating
                              class="pa-0 ma-0"
                              :value="calculateAverageScore(activity.id).rating"
                              :background-color="companyPrimaryColor"
                              :color="companyPrimaryColor"
                              half-increments
                              size="18"
                              readonly
                            ></v-rating>
                          </template>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content
                          class="dossier-expansion-content ma-0 pa-0"
                        >
                          <v-container grid-list-md fluid class="ma-0 pa-2">
                            <v-layout
                              v-for="(criterium, index) in activity.criteria"
                              :key="index"
                              row
                              wrap
                              class="ma-0 pa-0 pt-2"
                            >
                              <v-flex xs12>
                                <h3>
                                  <strong>{{ criterium.title }}</strong>
                                </h3>
                                <p class="ma-0">{{ criterium.description }}</p>
                              </v-flex>
                              <v-flex xs6>
                                <v-card flat class=" pa-1 pb-0 pl-0 ">
                                  <p class="ma-0">
                                    <strong>Beoordeling</strong>
                                  </p>
                                  <v-rating
                                    class="pa-0 ma-0"
                                    v-model="criterium.rating"
                                    :background-color="companyPrimaryColor"
                                    :color="companyPrimaryColor"
                                  ></v-rating>
                                  <v-textarea
                                    background-color="background"
                                    class="mt-3"
                                    label="Opmerkingen"
                                    outlined
                                    counter
                                    rows="2"
                                    v-model="criterium.notes"
                                  ></v-textarea>
                                </v-card>
                              </v-flex>
                              <v-flex xs6>
                                <v-card
                                  outlined
                                  color="background"
                                  class=" pa-1 pb-0"
                                  v-if="
                                    latestClientDossierHistory &&
                                      checkReviewHistory(
                                        activity.id,
                                        criterium.uniqid,
                                      ) >= 0
                                  "
                                >
                                  <p class="ma-0">
                                    <i>Vorige beoordeling</i> ({{
                                      latestClientDossierHistory.date
                                        | moment("D MMM YYYY")
                                    }})
                                  </p>
                                  <v-rating
                                    class="pa-0 ma-0"
                                    :value="
                                      checkReviewHistory(
                                        activity.id,
                                        criterium.uniqid,
                                      )
                                    "
                                    background-color="#8B93A6"
                                    color="#8B93A6"
                                    readonly
                                  ></v-rating>
                                  <v-textarea
                                    class="mt-3 mb-1"
                                    label="Opmerkingen"
                                    disabled
                                    background-color="menu"
                                    outlined
                                    readonly
                                    rows="2"
                                    :value="
                                      checkNotesHistory(
                                        activity.id,
                                        criterium.uniqid,
                                      )
                                    "
                                    hide-details
                                  ></v-textarea>
                                </v-card>
                              </v-flex>

                              <v-flex xs12>
                                <v-divider></v-divider>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-card>

                  <v-card
                    class="text-center pa-4"
                    flat
                    v-if="
                      newDossier.employee &&
                        resultActivitiesFiltered.length == 0
                    "
                    color="background"
                  >
                    <v-icon size="48" :color="companyPrimaryColor"
                      >star_half</v-icon
                    >
                    <p class="ma-0 pt-4">
                      Medewerker geselecteerd en geen activiteiten aanwezig.
                    </p>
                  </v-card>

                  <v-card
                    class="text-center pa-4"
                    flat
                    v-if="!newDossier.employee"
                    color="background"
                  >
                    <v-icon size="48" :color="companyPrimaryColor"
                      >star_half</v-icon
                    >
                    <p class="ma-0 pt-4">Nog geen medewerker geselecteerd.</p>
                  </v-card>
                </div>

                <div v-else class="loading-dots">
                  <div class="loading-dots-loader"></div>
                  <p class="loading-dots-text"></p>
                </div>
              </v-flex>

              <v-flex xs12>
                <v-textarea
                  class="mt-4"
                  outlined
                  rows="10"
                  :color="companyPrimaryColor"
                  background-color="background"
                  hide-details
                  label="Notities"
                  v-model="newDossier.notes"
                  required
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-container grid-list-md fluid class="ma-0 pa-0">
          <v-layout row wrap class="ma-0 pa-0">
            <v-flex
              xs12
              md6
              class="text-left"
              v-if="
                $vuetify.breakpoint.name != 'sm' &&
                  $vuetify.breakpoint.name != 'xs'
              "
            >
              <v-btn
                outlined
                depressed
                color="#8B93A6"
                @click="closeNewDossierDialog()"
              >
                Annuleren
              </v-btn>
            </v-flex>
            <v-flex xs12 md6 class="text-right">
              <v-btn
                v-if="docId"
                dark
                rounded
                :loading="autosaveBusy"
                :block="
                  $vuetify.breakpoint.name == 'sm' ||
                    $vuetify.breakpoint.name == 'xs'
                "
                :color="companySecondaryColor"
                @click="updateDossier('manual')"
              >
                Gesprek opslaan
                <v-icon right dark>chevron_right</v-icon>
              </v-btn>
              <v-btn
                v-else
                dark
                rounded
                :loading="autosaveBusy"
                :block="
                  $vuetify.breakpoint.name == 'sm' ||
                    $vuetify.breakpoint.name == 'xs'
                "
                :color="companySecondaryColor"
                @click="addDossier('manual')"
              >
                Gesprek opslaan
                <v-icon right dark>chevron_right</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { bus } from "../../main";
import db from "../../firebase/init";
import firebase from "firebase/compat/app";
import moment from "moment";

export default {
  name: "add-dossier-form",
  props: {
    activeCompData: Object,
    employees: Array,
    positions: Array,
    resultAreas: Array,
    resultActivities: Array,
  },

  data() {
    return {
      showDialog: false,
      newDossier: {
        title: null,
        type: "performanceReview",
        employee: null,
        attendees: null,
        notes: null,
      },
      savedDossier: null,
      rules: [(v) => v.length <= 25 || "Max 25 characters"],

      resultActivitiesFiltered: [],
      resultActivitiesLoading: false,
      latestClientDossierHistory: null,

      dossierTypes: [
        {
          id: "performanceReview",
          name: "Functioneringsgesprek",
        },
        {
          id: "midtermReview",
          name: "Tussentijdse beoordeling",
        },
        {
          id: "other",
          name: "Overig",
        },
      ],
      feedback: null,
      docId: null,
      autosaveBusy: false,
      interval: null,
    };
  },

  created() {
    bus.$on("openAddDossierModal", () => {
      this.setAutoUpdate();
      this.showDialog = true;
    });
  },

  methods: {
    setAutoUpdate() {
      this.interval = setInterval(
        () => {
          this.autosave();
        },
        30000, // every 30 seconds
      );
    },

    autosave() {
      console.log("resultActivitiesFiltered: ", this.resultActivitiesFiltered);
      if (
        this.newDossier.title &&
        this.newDossier.attendees &&
        this.newDossier.employee
      ) {
        if (this.dossierChanged && !this.autosaveBusy) {
          if (this.docId) {
            console.log("Autosave Update");
            this.updateDossier("auto");
          } else {
            console.log("Autosave (first)");
            this.addDossier("auto");
          }
        } else {
          console.log("Autosave Canceled. Nothing changed");
        }
      } else {
        console.log("Autosave Canceled. Not enough data");
      }
    },

    closeNewDossierDialog() {
      // this.$emit("newJourneyDialogChange", false);
      clearInterval(this.interval);
      this.showDialog = false;
      this.savedDossier = null;
      this.savedResultActivitiesFiltered = null;
      this.resetDossierModal();
    },

    resetDossierModal() {
      this.newDossier = {
        title: null,
        type: "performanceReview",
        employee: null,
        attendees: null,
        notes: null,
      };
    },

    getEmployeePosition(position) {
      let employeePosition = _.filter(this.positions, { id: position });
      return employeePosition.name;
    },

    employeeSelected() {
      this.resultActivitiesLoading = true;
      this.resultActivitiesFiltered = [];
      this.savedResultActivitiesFiltered = null;
      let counter = 0;
      new Promise((resolve) => {
        this.resultActivities.forEach((activity) => {
          if (activity.position == this.newDossier.employee.position) {
            this.resultActivitiesFiltered.push(activity);
          }
          counter++;
          if (counter == this.resultActivities.length) {
            resolve();
          }
        });
      }).then(() => {
        this.getEmployeeHistory();
        this.resultActivitiesLoading = false;
      });
    },

    getEmployeeHistory() {
      this.latestClientDossierHistory = null;
      let history = [];
      db.collection("conversationRecords")
        .where("compId", "==", this.activeCompData.id)
        .where("employee.id", "==", this.newDossier.employee.id)
        .where("created", "<", new Date())
        .orderBy("created", "desc")
        .get()
        .then((snap) => {
          if (snap.size > 0) {
            snap.forEach((doc) => {
              let item = doc.data();
              item.date = moment
                .unix(doc.data().created.seconds)
                .format("YYYY-MM-DD");
              history.push(item);
            });
          }
        })
        .then(() => {
          this.latestClientDossierHistory = history[0];
        });
    },

    checkReviewHistory(activityId, criteriumUniqid) {
      let rating = null;
      if (this.latestClientDossierHistory) {
        let index = _.findIndex(this.latestClientDossierHistory.review, {
          id: activityId,
        });
        if (index >= 0) {
          let data = _.find(
            this.latestClientDossierHistory.review[index].criteria,
            { uniqid: criteriumUniqid },
          );
          if (data) {
            rating = data.rating;
            return rating;
          } else {
            return rating;
          }
        } else {
          return rating;
        }
      } else {
        return rating;
      }
    },

    checkNotesHistory(activityId, criteriumUniqid) {
      let notes = null;
      if (this.latestClientDossierHistory) {
        let index = _.findIndex(this.latestClientDossierHistory.review, {
          id: activityId,
        });
        if (index >= 0) {
          let data = _.find(
            this.latestClientDossierHistory.review[index].criteria,
            { uniqid: criteriumUniqid },
          );
          if (data) {
            notes = data.notes;
            return notes;
          } else {
            return notes;
          }
        } else {
          return notes;
        }
      } else {
        return notes;
      }
    },

    addDossier(type) {
      this.autosaveBusy = true;
      if (
        this.newDossier.title &&
        this.newDossier.attendees &&
        this.newDossier.employee
      ) {
        db.collection("conversationRecords")
          .add({
            title: this.newDossier.title,
            created: new Date(),
            type: this.newDossier.type,
            compId: this.activeCompData.id,
            employee: this.newDossier.employee,
            attendees: this.newDossier.attendees,
            review: this.resultActivitiesFiltered,
            notes: this.newDossier.notes,
            deleted: {
              deleted: false,
            },
          })
          .then(() => {
            db.collection("log")
              .add({
                time: new Date(),
                logType: "info",
                user: this.userFirstName + " " + this.userLastName,
                userType: this.userRole,
                company: this.userCompany,
                actionType: "User Action",
                action:
                  "Nieuw gespreksverslag toegevoegd: " +
                  this.activeCompData.name,
                extra:
                  "<b>title:</b> " +
                  this.newDossier.name +
                  "<br>" +
                  "<b>Type:</b> " +
                  this.newDossier.type +
                  "<br>" +
                  "<b>Aanwezigen:</b> " +
                  this.newDossier.attendees +
                  "<br>" +
                  "<b>Notities:</b> " +
                  this.newDossier.notes,
              })
              .then((docRef) => {
                this.docId = docRef.id;
              })
              .catch((error) => {
                console.error("Error logging new conversationRecords: ", error);
              });
          })
          .then(() => {
            this.autosaveBusy = false;
            this.savedDossier = _.cloneDeep(this.newDossier);
            this.savedResultActivitiesFiltered = _.cloneDeep(
              this.resultActivitiesFiltered,
            );
            this.$emit("updateData");
            if (type == "manual") {
              this.closeNewDossierDialog();
            }
          })
          .catch((error) => {
            console.error("Error adding conversationRecords: ", error);
            db.collection("log").add({
              time: new Date(),
              logType: "error",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              action:
                "Error adding conversation records: " + this.activeComp.name,
              extra: JSON.stringify(error),
            });
          });
      } else {
        this.feedback =
          "Vul de verplichte velden in om een gespreksverslag toe te voegen";
      }
    },

    updateDossier(type) {
      this.autosaveBusy = true;
      db.collection("conversationRecords")
        .doc(this.docId)
        .set(
          {
            title: this.newDossier.title,
            type: this.newDossier.type,
            compId: this.activeCompData.id,
            employee: this.newDossier.employee,
            attendees: this.newDossier.attendees,
            review: this.resultActivitiesFiltered,
            notes: this.newDossier.notes,
            deleted: {
              deleted: false,
            },
          },
          { merge: true },
        )
        .then(() => {
          this.autosaveBusy = false;
          this.savedDossier = _.cloneDeep(this.newDossier);
          this.savedResultActivitiesFiltered = _.cloneDeep(
            this.resultActivitiesFiltered,
          );
          if (type == "manual") {
            this.$emit("updateData");
            this.closeNewDossierDialog();
          }
        })
        .catch((error) => {
          console.error("Error updating conversationRecords: ", error);
        });
    },
  },

  computed: {
    dossierChanged() {
      // Kijken of content veranderd is
      if (
        _.isEqual(this.newDossier, this.savedDossier) == false ||
        _.isEqual(
          this.resultActivitiesFiltered,
          this.savedResultActivitiesFiltered,
        ) == false
      ) {
        return true;
      } else {
        return false;
      }
    },

    calculateAverageScore() {
      return (id) => {
        let data = {
          rating: 0,
          ratings: 0,
        };

        let index = _.findIndex(this.resultActivitiesFiltered, { id: id });

        if (index >= 0) {
          let counter = 0;
          let ratings = 0;
          let totalRating = 0;
          this.resultActivitiesFiltered[index].criteria.forEach((criterium) => {
            if (criterium.rating) {
              ratings++;
              totalRating = totalRating + criterium.rating;
            }
          });
          if (ratings > 0) {
            data.ratings = ratings;
            data.rating = Number((totalRating / ratings).toFixed(1));
          }
          return data;
        } else {
          return data;
        }
      };
    },

    calculateAverageScoreHistory() {
      return (id) => {
        let data = {
          rating: 0,
          ratings: 0,
        };

        let index = _.findIndex(this.latestClientDossierHistory.review, {
          id: id,
        });

        if (index >= 0) {
          let counter = 0;
          let ratings = 0;
          let totalRating = 0;
          this.latestClientDossierHistory.review[index].criteria.forEach(
            (criterium) => {
              if (criterium.rating) {
                ratings++;
                totalRating = totalRating + criterium.rating;
              }
            },
          );
          if (ratings > 0) {
            data.ratings = ratings;
            data.rating = Number((totalRating / ratings).toFixed(1));
          }
          return data;
        } else {
          return data;
        }
      };
    },

    userRole() {
      return this.$store.state.userRole;
    },
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
};
</script>
<style>
.dossier-expansion-header {
  font-size: 18px;
  font-weight: bold;
  padding: 10px 18px;
  min-height: 48px !important;
  border-bottom: 1px solid var(--v-menuborder-base);
  background-color: var(--v-background-base);
}

.dossier-expansion-content .v-expansion-panel-content__wrap {
  margin: 0 !important;
  padding: 0 !important;
}

.score-indicator {
  width: 40px;
  height: 40px;
  background-color: black;
  display: block;
  position: relative;
}
</style>
